import classNames from 'classnames';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import Spinner from 'src/component/Spinner';
import MultiSizeDrawer from 'src/component/MultiSizeDrawer';
import { Store } from 'src/store';
import isDesignLoading from 'src/store/design/selector/isDesignLoading';
import isDesignSaving from 'src/store/design/selector/isDesignSaving';
import { closeMultiSizeDrawerAction } from 'src/store/multisize/slice';
import useIntegrationLayer from 'src/util/hook/useIntegrationLayer';
import styles from './index.module.scss';

interface OwnProps {
}

interface Props extends OwnProps {
  isLoading: boolean;
  isSaving: boolean;
  isMultiSizeDrawerOpen: boolean;
  dispatch: ThunkDispatch<Store, void, AnyAction>;
}

export const editorIframeElementId = 'editorIframe';

const Editor = (
  {
    isLoading,
    isSaving,
    isMultiSizeDrawerOpen,
    dispatch,
  }: Props,
) => {
  const [timestamp] = useState(new Date().getTime());
  const { designerAppUrl } = useIntegrationLayer();
  return (
    <div
      className={classNames({
        [styles.editor]: true,
      })}
    >
      {isLoading || isSaving ? (<div className={styles.spinner}><Spinner /></div>) : null}
      {isMultiSizeDrawerOpen && (
        <MultiSizeDrawer onClose={() => dispatch(closeMultiSizeDrawerAction())} />
      )}
      <iframe
        src={`${designerAppUrl}?${timestamp}`}
        title="designer"
        data-hj-allow-iframe=""
        frameBorder="0"
        height="100%"
        width="100%"
        id={editorIframeElementId}
        className={classNames({
          [styles.noEvents]: isLoading,
        })}
      />
    </div>
  );
};

const mapStateToProps = (store: Store, ownProps: OwnProps) => ({
  isLoading: isDesignLoading(store),
  isSaving: isDesignSaving(store),
  isMultiSizeDrawerOpen: store.multisize.isOpen,
});

export default connect(mapStateToProps)(Editor);
